import React from "react"

import { StudySessionFilters } from "client/store"
import { SearchBar } from "client/components"

interface SearchStudySession {
    id: string
    leftOffset?: boolean
    rightOffset?: boolean
    filters: StudySessionFilters
    onFilter: (filters: StudySessionFilters) => void
}

const StudySessionSearch = ({
    id,
    leftOffset = false,
    rightOffset = false,
    filters,
    onFilter,
}: SearchStudySession) => (
    <SearchBar
        id={id}
        filters={filters}
        leftOffset={leftOffset}
        rightOffset={rightOffset}
        onFilter={onFilter}
    />
)
export default StudySessionSearch
